
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import LinkOffIcon from '@mui/icons-material/LinkOff';

import moment from 'moment';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { ObtenerSentidoAmparo } from '../connections/catalogos/SentidoAmparoConnection';
import { ObtenerAutoridadAmparo } from '../connections/catalogos/AutoridadAmparoConnection';
import { ObtenerTipoAmparo } from '../connections/catalogos/TipoAmparoConnection';
import { BuscarSecretariosEjecucion, ObtenerUsuarioJuez } from '../connections/admin/UsuarioConnection';
import { AsignarExpedienteAmparo } from '../connections/recepcion/AmparoConnection';
import { EditarAmparo } from '../connections/tribunal/ExpedienteVirtualConnection';

import { DialogBuscarExpedienteAmparo } from './DialogBuscarExpedienteAmparo';

import { AmparoProps } from '../interfaces/tribunal/ExpedienteVirtualInterface';
import { SentidoAmparoProps } from '../interfaces/catalogos/SentidoAmparoInterface';
import { AutoridadAmparoProps } from '../interfaces/catalogos/AutoridadAmparoInterface';
import { TipoAmparoProps } from '../interfaces/catalogos/TipoAmparoInterface';
import { UsuarioJuezProps, UsuarioSecretarioProps } from '../interfaces/admin/UsuarioInterface';

interface Props {
    openDialog:         boolean;
    handleCloseDialog:  () => void;
    amparo:             AmparoProps;
    onGuardar:          ( amparo: AmparoProps ) => void;
}

export const DialogEditarAmparo = ( { openDialog, handleCloseDialog, amparo, onGuardar }: Props ) => {

    const dispatch = useDispatch();

    const [guardando, setGuardando] = useState( false );

    const [numeroExpedienteMostrado, setNumeroExpedienteMostrado] = useState( '' );
    const [selectedExpedienteId, setSelectedExpedienteId] = useState( 0 );
    const [openDialogBuscarExpediente, setOpenDialogBuscarExpediente] = useState( false );
    const [openConfirmarQuitarExpediente, setOpenConfirmarQuitarExpediente] = useState( false );
    const [loadingQuitarExpediente, setLoadingQuitarExpediente] = useState( false );
    const [removeExpedienteRequested, setRemoveExpedienteRequested] = useState( false );

    const [sentidoAmparoArray, setSentidoAmparoArray] = useState<SentidoAmparoProps[]>( [] );
    const [autoridadAmparoArray, setAutoridadAmparoArray] = useState<AutoridadAmparoProps[]>( [] );
    const [tipoAmparoArray, setTipoAmparoArray] = useState<TipoAmparoProps[]>( [] );
    const [juezArray, setJuezArray] = useState<UsuarioJuezProps[]>( [] );
    const [secretariosArray, setSecretariosArray] = useState<UsuarioSecretarioProps[]>( [] );

    const [sentidoAmparoEditado, setSentidoAmparoEditado] = useState( 0 );
    const [autoridadAmparoEditada, setAutoridadAmparoEditada] = useState( 0 );
    const [tipoAmparoEditado, setTipoAmparoEditado] = useState( 0 );
    const [juezEditado, setJuezEditado] = useState( 0 );
    const [secretarioEditado, setSecretarioEditado] = useState( 0 );
    const [numeroAmparoOrigenEditado, setNumeroAmparoOrigenEditado] = useState( '' );
    const [fechaInformePrevioEditada, setFechaInformePrevioEditada] = useState( '' );
    const [fechaInformeJustificadoEditada, setFechaInformeJustificadoEditada] = useState( '' );
    const [fechaInterponeEditada, setFechaInterponeEditada] = useState( '' );
    const [fechaResolucionEditada, setFechaResolucionEditada] = useState( '' );

    const handleQuitarExpediente = async () => {

        setLoadingQuitarExpediente( true );

        setTimeout(() => {
            
            setRemoveExpedienteRequested( true );
            setNumeroExpedienteMostrado( '' );
            setSelectedExpedienteId( 0 );
            setOpenConfirmarQuitarExpediente( false );

            setLoadingQuitarExpediente( false );

        }, 700);

    }

    const handleChangeTipoAmparo = ( value: number ) => {

        setTipoAmparoEditado( value );
        setAutoridadAmparoEditada( value === 1 ? 2 : value === 2 ? 1 : 0 );

        if( value === 1 ){
            setNumeroAmparoOrigenEditado( '' );
        }

    }

    const handleGuardar = async () => {

        setGuardando( true );

        const sentidoAmparoDescripcion = sentidoAmparoArray.find( ({ idSentidoAmparo }) => idSentidoAmparo === sentidoAmparoEditado )?.descripcion ?? '';
        const autoridadAmparoDescripcion = autoridadAmparoArray.find( ({ idAutoridadAmparo }) => idAutoridadAmparo === autoridadAmparoEditada )?.descripcion ?? '';
        const tipoAmparoDescripcion = tipoAmparoArray.find( ({ idTipoAmparo }) => idTipoAmparo === tipoAmparoEditado )?.descripcion ?? '';
        const juezDescripcion = juezArray.find( ({ idUsuario }) => idUsuario === juezEditado )?.nombreCompleto ?? '';
        const secretarioDescripcion = secretariosArray.find( ({ id }) => id === secretarioEditado )?.nombreCompleto ?? '';

        const numeroAmparoOrigen = tipoAmparoEditado === 1 ? '' : numeroAmparoOrigenEditado;

        await EditarAmparo({
            idAmparo:                   amparo.idAmparo,
            idSentidoAmparo:            sentidoAmparoEditado,
            idAutoridadAmparo:          autoridadAmparoEditada,
            idTipoAmparo:               tipoAmparoEditado,
            idJuez:                     juezEditado,
            idSecretario:               secretarioEditado,
            numeroAmparoOrigen:         numeroAmparoOrigen,
            fechaInformePrevio:         fechaInformePrevioEditada,
            fechaInformeJustificado:    fechaInformeJustificadoEditada,
            fechaInterpone:             fechaInterponeEditada,
            fechaResolucion:            fechaResolucionEditada,
        }).then( async resp => {

            setTimeout(async () => {

                const { success, message } = resp;

                if( success ){

                    if( removeExpedienteRequested ){

                        await AsignarExpedienteAmparo({ idAmparo: amparo.idAmparo, idExpediente: 0 }).then( asignResp => {

                            const { success: successAsign, message: messageAsign } = asignResp;

                            if( !successAsign ){
                                dispatch( openSnackbar({ message: messageAsign, variant: 'error' }) );
                            }

                        });

                        setRemoveExpedienteRequested( false );

                    }
                    else if( selectedExpedienteId && selectedExpedienteId !== 0 ){

                        await AsignarExpedienteAmparo({ idAmparo: amparo.idAmparo, idExpediente: selectedExpedienteId }).then( asignResp => {

                            const { success: successAsign, message: messageAsign } = asignResp;

                            if( !successAsign ){
                                dispatch( openSnackbar({ message: messageAsign, variant: 'error' }) );
                            }

                        });

                    }

                    onGuardar({
                        ...amparo,
                        numeroAmparoOrigen:         numeroAmparoOrigen,
                        idSentidoAmparo:            sentidoAmparoEditado,
                        sentidoAmparo:              sentidoAmparoDescripcion,
                        idAutoridadAmparo:          autoridadAmparoEditada,
                        autoridadAmparo:            autoridadAmparoDescripcion,
                        idTipoAmparo:               tipoAmparoEditado,
                        tipoAmparo:                 tipoAmparoDescripcion,
                        idJuez:                     juezEditado,
                        juez:                       juezDescripcion,
                        idSecretario:               secretarioEditado,
                        secretario:                 secretarioDescripcion,
                        fechaInformePrevio:         fechaInformePrevioEditada ? new Date( fechaInformePrevioEditada ) : undefined,
                        fechaInformeJustificado:    fechaInformeJustificadoEditada ? new Date( fechaInformeJustificadoEditada ) : undefined,
                        fechaInterpone:             fechaInterponeEditada ? new Date( fechaInterponeEditada ) : undefined,
                        fechaResolucion:            fechaResolucionEditada ? new Date( fechaResolucionEditada ) : undefined,
                        numeroExpediente:           numeroExpedienteMostrado,
                    });

                    dispatch( openSnackbar({ message, variant: 'success' }) );
                    handleCloseDialog();

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

                setGuardando( false );

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener(){
            await ObtenerSentidoAmparo().then( resp => {
                setSentidoAmparoArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerAutoridadAmparo().then( resp =>{
                setAutoridadAmparoArray( resp ) 
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerTipoAmparo().then( resp => {
                setTipoAmparoArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerUsuarioJuez().then( resp => {
                setJuezArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){

            await BuscarSecretariosEjecucion().then( resp => {
                setSecretariosArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        if( openDialog ){

            setNumeroExpedienteMostrado( amparo.numeroExpediente );
            setSelectedExpedienteId( 0 );
            setRemoveExpedienteRequested( false );
            setNumeroAmparoOrigenEditado( amparo.numeroAmparoOrigen );
            setFechaInformePrevioEditada( amparo.fechaInformePrevio ? moment( amparo.fechaInformePrevio ).format( 'YYYY-MM-DDTHH:mm' ) : '' );
            setFechaInformeJustificadoEditada( amparo.fechaInformeJustificado ? moment( amparo.fechaInformeJustificado ).format( 'YYYY-MM-DDTHH:mm' ) : '' );
            setFechaInterponeEditada( amparo.fechaInterpone ? moment( amparo.fechaInterpone ).format( 'YYYY-MM-DDTHH:mm' ) : '' );
            setFechaResolucionEditada( amparo.fechaResolucion ? moment( amparo.fechaResolucion ).format( 'YYYY-MM-DDTHH:mm' ) : '' );
            setSentidoAmparoEditado( amparo.idSentidoAmparo );
            setAutoridadAmparoEditada( amparo.idAutoridadAmparo );
            setTipoAmparoEditado( amparo.idTipoAmparo );
            setJuezEditado( amparo.idJuez );
            setSecretarioEditado( amparo.idSecretario );

        }

    }, [ openDialog, amparo ]);

    return (

        <>

        <Dialog
            fullWidth
            maxWidth='md'
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>Editar amparo</DialogTitle>

            <DialogContent>

                <Grid container spacing={3} sx={{ mt: 1 }}>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                            <TextField
                                fullWidth
                                disabled
                                label='Número de expediente'
                                value={ numeroExpedienteMostrado }
                                slotProps={{
                                    inputLabel: {
                                        shrink: true
                                    }
                                }}
                            />

                            <IconButton color='primary' onClick={ () => setOpenDialogBuscarExpediente( true ) }>
                                <EditIcon />
                            </IconButton>

                            {
                                numeroExpedienteMostrado
                                &&
                                    <IconButton color='error' onClick={ () => setOpenConfirmarQuitarExpediente( true ) }>
                                        <LinkOffIcon />
                                    </IconButton>
                            }

                        </Box>

                    </Grid>
                    
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Tipo de amparo</InputLabel>

                            <Select
                                notched
                                label='Tipo de amparo'
                                value={ tipoAmparoEditado }
                                onChange={ (e) => handleChangeTipoAmparo( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    tipoAmparoArray.map( ({ idTipoAmparo, descripcion }) => (
                                        <MenuItem key={ idTipoAmparo } value={ idTipoAmparo }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>      
            
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Sentido del amparo</InputLabel>

                            <Select
                                notched
                                label='Sentido del amparo'
                                value={ sentidoAmparoEditado }
                                onChange={ (e) => setSentidoAmparoEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    sentidoAmparoArray.map( ({ idSentidoAmparo, descripcion }) => (
                                        <MenuItem key={ idSentidoAmparo } value={ idSentidoAmparo }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>
            
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Autoridad del amparo</InputLabel>

                            <Select
                                notched
                                disabled
                                label='Autoridad del amparo'
                                value={ autoridadAmparoEditada }
                                onChange={ (e) => setAutoridadAmparoEditada( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    autoridadAmparoArray.map( ({ idAutoridadAmparo, descripcion }) => (
                                        <MenuItem key={ idAutoridadAmparo } value={ idAutoridadAmparo }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>                    
                   
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Juez</InputLabel>

                            <Select
                                notched
                                label='Juez'
                                value={ juezEditado }
                                onChange={ (e) => setJuezEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    juezArray.map( ({ idUsuario, nombreCompleto }) => (
                                        <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>                    

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a)</InputLabel>

                            <Select
                                notched
                                label='Secretario(a)'
                                value={ secretarioEditado }
                                onChange={ (e) => setSecretarioEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>
                   
                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            label='Número de amparo de origen'
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                            value={ numeroAmparoOrigenEditado }
                            onChange={ (e) => setNumeroAmparoOrigenEditado( e.target.value ) }
                        />

                    </Grid>
                    
                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            type='datetime-local'
                            label='Fecha de informe previo'
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={ fechaInformePrevioEditada }
                            onChange={ (e) => setFechaInformePrevioEditada( e.target.value ) }
                        />

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            type='datetime-local'
                            label='Fecha de informe justificado'
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={ fechaInformeJustificadoEditada }
                            onChange={ (e) => setFechaInformeJustificadoEditada( e.target.value ) }
                        />

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            type='datetime-local'
                            label='Fecha de interposición'
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={ fechaInterponeEditada }
                            onChange={ (e) => setFechaInterponeEditada( e.target.value ) }
                        />

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            type='datetime-local'
                            label='Fecha de resolución'
                            slotProps={{ inputLabel: { shrink: true } }}
                            value={ fechaResolucionEditada }
                            onChange={ (e) => setFechaResolucionEditada( e.target.value ) }
                        />

                    </Grid>

                </Grid>

            </DialogContent>

            <DialogActions>
                <Button color='secondary' onClick={ handleCloseDialog } disabled={ guardando }>Cancelar</Button>
                <Button variant='contained' loading={ guardando } onClick={ handleGuardar }>Guardar</Button>
            </DialogActions>

        </Dialog>

        <DialogBuscarExpedienteAmparo
            idAmparo={ amparo.idAmparo }
            openDialog={ openDialogBuscarExpediente }
            handleCloseDialog={ () => setOpenDialogBuscarExpediente( false ) }
            onGuardar={ (expediente) => {
                setSelectedExpedienteId( expediente.idExpediente ?? 0 );
                setNumeroExpedienteMostrado( expediente.numeroExpediente );

                setRemoveExpedienteRequested( false );
                setOpenDialogBuscarExpediente( false );
            }}
        />

        <Dialog
            fullWidth
            maxWidth='xs'
            open={ openConfirmarQuitarExpediente }
            onClose={ () => {} }
        >

            <DialogTitle>Confirmación</DialogTitle>

            <DialogContent>

                <DialogContentText>
                    ¿Desea quitar el expediente asignado al amparo?
                </DialogContentText>

            </DialogContent>

            <DialogActions>
                <Button color='secondary' onClick={ () => setOpenConfirmarQuitarExpediente( false ) } disabled={ loadingQuitarExpediente }>Cancelar</Button>
                <Button variant='contained' loading={ loadingQuitarExpediente } onClick={ handleQuitarExpediente }>Aceptar</Button>
            </DialogActions>

        </Dialog>

        </>

    );

}
